export default __webpack_public_path__ + "static/media/sg-icon.b059c011.svg";